type StorageScope = 'local' | 'session';

const memoryStore = new Map<string, string>();

function getWebStorage(scope: StorageScope): Storage | null {
  if (typeof window === 'undefined') {
    return null;
  }
  try {
    return scope === 'local' ? window.localStorage : window.sessionStorage;
  } catch {
    return null;
  }
}

function scopedKey(scope: StorageScope, key: string): string {
  return `${scope}:${key}`;
}

export function storageGet(key: string, scope: StorageScope = 'local'): string | null {
  const webStorage = getWebStorage(scope);
  if (webStorage) {
    return webStorage.getItem(key);
  }
  return memoryStore.get(scopedKey(scope, key)) ?? null;
}

export function storageSet(key: string, value: string, scope: StorageScope = 'local'): void {
  const webStorage = getWebStorage(scope);
  if (webStorage) {
    webStorage.setItem(key, value);
    return;
  }
  memoryStore.set(scopedKey(scope, key), value);
}

export function storageRemove(key: string, scope: StorageScope = 'local'): void {
  const webStorage = getWebStorage(scope);
  if (webStorage) {
    webStorage.removeItem(key);
    return;
  }
  memoryStore.delete(scopedKey(scope, key));
}

export function storageClear(scope?: StorageScope): void {
  if (!scope) {
    const localStorage = getWebStorage('local');
    const sessionStorage = getWebStorage('session');
    if (localStorage) localStorage.clear();
    if (sessionStorage) sessionStorage.clear();
    memoryStore.clear();
    return;
  }

  const webStorage = getWebStorage(scope);
  if (webStorage) {
    webStorage.clear();
    return;
  }

  for (const key of Array.from(memoryStore.keys())) {
    if (key.startsWith(`${scope}:`)) {
      memoryStore.delete(key);
    }
  }
}
